import { fetchAPI, API_BASE_URL } from "./apiCore";
import { getToken, getuserId } from "./auth";


// --- New Follow-Up APIs ---

export const fetchFollowUpDashboard = async (params = {}) => {
  return fetchAPI("biobank/follow-ups/dashboard", "GET", params);
};


export const fetchFollowUpBatchOptions = async (params = {}) => {
  return fetchAPI("biobank/follow-ups/batch-options", "GET", params);
};


export const fetchFollowUpPatientOptions = async (params = {}) => {
  return fetchAPI("biobank/follow-ups/patient-options", "GET", params);
};


export const fetchFollowUpEnrollmentPreview = async (batchId) => {
  return fetchAPI("biobank/follow-ups/enrollment-preview", "GET", { batchId });
};


export const enrollFollowUp = async (payload) => {
  return fetchAPI("biobank/follow-ups/enroll", "POST", {}, payload);
};


export const fetchFollowUpActionItems = async (params = {}) => {
  return fetchAPI("biobank/follow-ups/action-items", "GET", params);
};


export const fetchFutureFollowUps = async (params = {}) => {
  return fetchAPI("biobank/follow-ups/future", "GET", params);
};


export const fetchEmails = async (params = {}) => {
  const queryParams = Object.entries(params).reduce((acc, [key, value]) => {
    if (value !== null && value !== undefined && value !== "") {
      acc[key] = value;
    }
    return acc;
  }, {});

  return fetchAPI("biobank/emails", "GET", queryParams);
};


export const fetchEmailById = async (emailId) => {
  return fetchAPI(`biobank/emails/${encodeURIComponent(emailId)}`, "GET");
};


export const matchEmailPatient = async (emailId, patientId) => {
  return fetchAPI(
    `biobank/emails/${encodeURIComponent(emailId)}/patient`,
    "PATCH",
    {},
    { patientId },
  );
};


export const unmatchEmailPatient = async (emailId) => {
  return fetchAPI(
    `biobank/emails/${encodeURIComponent(emailId)}/patient`,
    "DELETE",
  );
};


export const fetchEmailTemplates = async (params = {}) => {
  const queryParams = Object.entries(params).reduce((acc, [key, value]) => {
    if (value !== null && value !== undefined && value !== "") {
      acc[key] = value;
    }
    return acc;
  }, {});

  return fetchAPI("biobank/email-templates", "GET", queryParams);
};


export const fetchEmailTemplateSpecs = async (params = {}) => {
  const queryParams = Object.entries(params).reduce((acc, [key, value]) => {
    if (value !== null && value !== undefined && value !== "") {
      acc[key] = value;
    }
    return acc;
  }, {});

  return fetchAPI("biobank/email-template-specs", "GET", queryParams);
};


export const saveEmailTemplate = async (specCode, language, payload) => {
  return fetchAPI(
    `biobank/email-templates/${encodeURIComponent(specCode)}/${encodeURIComponent(language)}`,
    "PUT",
    {},
    payload,
  );
};


export const previewEmailTemplate = async (payload) => {
  return fetchAPI("biobank/email-templates/preview", "POST", {}, payload);
};


export const sendEmail = async (payload) => {
  return fetchAPI("biobank/emails/send", "POST", {}, payload);
};


export const sendFollowUpEmail = async (followUpId, payload) => {
  return fetchAPI(`biobank/follow-ups/${encodeURIComponent(followUpId)}/send-email`, "POST", {}, payload);
};


export const updateFollowUpContact = async (followUpId, payload) => {
  return fetchAPI(`biobank/follow-ups/${encodeURIComponent(followUpId)}/contact`, "PATCH", {}, payload);
};


export const confirmFollowUpAddress = async (followUpId, payload) => {
  return fetchAPI(`biobank/follow-ups/${encodeURIComponent(followUpId)}/address`, "PATCH", {}, payload);
};


export const updateFollowUpFulfillment = async (followUpId, payload) => {
  return fetchAPI(`biobank/follow-ups/${encodeURIComponent(followUpId)}/fulfillment`, "PATCH", {}, payload);
};


export const markFollowUpMissed = async (followUpId, payload) => {
  return fetchAPI(`biobank/follow-ups/${encodeURIComponent(followUpId)}/mark-missed`, "POST", {}, payload);
};
